import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    window.gtag?.("config", "G-VBNHH1932J", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}